import React from "react";
import styles from "./date-time-button.module.css";

const DateTimeButton = (props) => {
  const className = props.styles ? `${styles.button} ${props.styles}` : `${styles.button}`
  return (
    <select value={props.value} onChange={props.onChange} className={className} id={props.id} style={props.dateTimeButtonStyles}>
      {props.children}
    </select>
  );
};  

export { DateTimeButton };
